<template>
	<page>
		<module>
			<view-list ref="view" work-type="27" selector :view-config="auth('b_sysuser_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="账号">
							<c-input name="user_name"></c-input>
						</m-search-item>
						<m-search-item label="姓名">
							<c-input name="user_realname"></c-input>
						</m-search-item>
						<m-search-item label="手机号码">
							<c-input name="phone"></c-input>
						</m-search-item>
						<m-search-item label="角色">
							<c-select name="role_id" async @search="searchRole"></c-select>
						</m-search-item>
						<m-search-item label="部门">
							<c-select name="department_ids" async multiple @search="searchDepartment"></c-select>
						</m-search-item>
						<m-search-item v-if="saasInfo.max_v_account_count>0">
							<c-checkbox-group name="user_types" :options="userTypeDic"></c-checkbox-group>
						</m-search-item>
						<m-search-item>
							<c-checkbox-group name="state" :options="disableEnableDic"></c-checkbox-group>
						</m-search-item>
						<m-search-item>
							<c-checkbox-group name="pricing_types" :options="pricingTypeDic"></c-checkbox-group>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_sysuser_edit')" v-lock="lock('b_sysuser_edit')" prepend-icon="tf-add" @click="$refs.sysuserEdit.open()">创建用户</c-button>
                    <c-button v-if="auth('b_sysuser_export')" v-lock="lock('b_sysuser_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                    <c-button v-if="auth('b_sysuser_edit')" v-lock="lock('b_sysuser_edit')" prepend-icon="tf-import" @click="$refs.view.excelImport()">导入</c-button>
				</template>
				
				<template #batchOperate="{data}">
                    <c-button v-if="auth('b_sysuser_export')" v-lock="lock('b_sysuser_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_sysuser_print')" v-lock="lock('b_sysuser_print')"  prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_sysuser_log')" v-lock="lock('b_sysuser_log')" prepend-icon="tf-import-record" @click="$refs.view.loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_sysuser_log')" v-lock="lock('b_sysuser_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>
				
				<!--启禁用状态-->
				<template #state="{data}">
					<c-switch v-if="auth('b_sysuser_edit') && data.is_manage != 1 " v-model="data.state" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
					<c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
				</template>
				
				<!--计价方式-->
				<template #pricing_type="{data}">
					<c-state dict="pricingTypeDic" :value="data.pricing_type"></c-state>
				</template>
				
				<!--账号类型-->
				<template #user_type="{data}">
					<c-switch v-if="auth('b_sysuser_edit') && data.is_manage != 1 && saasInfo.max_v_account_count>0" v-model="data.user_type" :state-value="[1, 2]" :state-text="['员工','虚拟']" @beforeChange="userTypeHandle(arguments[0], arguments[1], data)"></c-switch>
					<c-state v-else dict="userTypeDic" :value="data.user_type"></c-state>
				</template>
				
				<!--锁定状态-->
				<template #is_lock="{data}">
					<c-state v-if="data.user_type == 1" dict="lockStateDic" :value="data.is_lock"></c-state>
					<span v-else>-</span>
				</template>
				
				<!--账号类型-->
				<template #user_type_tip="{data}" v-if="saasInfo.max_v_account_count>0">
					<c-tooltip align="end"  width="260" tip="">
						<template #tip>
							<p>类型说明：</p>
							<p>员工：允许登陆系统，占用系统账号数量</p>
							<p>虚拟：不允许登陆系统，一般用于替非正式员工代报工，不占用账号数量</p>
						</template>
					</c-tooltip>
				</template>

				<!--身份标签 -->
				<template #identity="{data}">
					<span v-if="!data.identity" >-</span>
					<c-tags v-else :value="data.identity"></c-tags>
				</template>
				
				<!--角色说明-->
				<template #identity_tip="{data}">
					<c-tooltip tip="提示" width="360">
						<template #tip>
							<p>身份说明：</p>
							<p>拥有老板或对接人身份的人,系统有新功能更新后会自动拥有相关权限</p>
						</template>
					</c-tooltip>
				</template>
				
				<!--部门 -->
				<template #department_names="{data}">
					<span v-if="!data.department_names" >-</span>
					<c-tags v-else :value="data.department_names"></c-tags>
				</template>
				
				<!--角色 -->
				<template #role_names="{data}">
					<template v-if="data.user_type == 1">
						<span v-if="!data.role_names" >-</span>
						<span v-else-if="data.auth_type==2" style="color:#999">{{data.role_names}}</span>
						<span v-else>{{data.role_names}}</span>
					</template>
					<template v-else>
						-
					</template>
				</template>
				
				<!--角色说明-->
				<template #role_names_tip="{data}">
					<c-tooltip tip="提示" width="360" >
						<template #tip>
							<p>角色说明：</p>
							<p>1、轻量-管理员、系统管理员角色拥有同组用户报工审批权限（需要有代报工权限）</p>
							<p>2、角色名称的颜色如果为灰色，代表权限已人工设置</p>
						</template>
					</c-tooltip>
				</template>
				
				<!--锁定状-->
				<template #is_lock_tip="{data}">
					<c-tooltip tip="提示" width="300">
						<template #tip>
							<p>锁定状态说明：</p>
							<p>锁定：登陆账户密码错误次数过多，账户将自动锁定，锁定后将无法使用账号密码方式登陆</p>
							<p>风险解除：风险解除后可正常使用账号密码方式登陆</p>
						</template>
					</c-tooltip>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="250"
					button-limit="4"
				>
					<template #default="{data}">
						<!-- <c-table-button v-if="auth('b_sysuser_edit')" v-lock="lock('b_sysuser_edit')" icon="tf-reset-password" color="red" @click="removeSysuser(data)">删除</c-table-button> -->
						<c-table-button v-if="auth('b_sysuser_edit')" v-lock="lock('b_sysuser_edit')" :disabled="!(data.user_type == 1)" icon="tf-reset-password" @click="resetPwd(data)">重置密码</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit')" v-lock="lock('b_sysuser_edit')" icon="tf-edit" @click="$refs.sysuserEdit.open(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_sysuser_print')" v-lock="lock('b_sysuser_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit') && data.is_manage != 1 && data.user_type == 1" v-lock="lock('b_sysuser_edit')" icon="tf-auth" @click="$refs.sysuserAuthConfig.open(data, 0)">电脑端权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit') && data.is_manage != 1 && data.user_type == 1" v-lock="lock('b_sysuser_edit')" icon="tf-auth" @click="$refs.sysuserAuthConfig.open(data, 1)">手机端权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit') && data.is_manage != 1 && data.user_type == 1" v-lock="lock('b_sysuser_edit')" icon="tf-copy" @click="$refs.sysuserAuthCopy.open(data, 0)">复制电脑端权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit') && data.is_manage != 1 && data.user_type == 1" v-lock="lock('b_sysuser_edit')" icon="tf-copy" @click="$refs.sysuserAuthCopy.open(data, 1)">复制手机端权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit') && data.user_type == 1 " v-lock="lock('b_sysuser_edit')" :disabled="data.is_lock == 0" icon="tf-lock" @click="riskRemoval(data)">账号解锁</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--编辑用户信息弹窗-->
			<sysuser-edit ref="sysuserEdit" @resolve="$refs.view.update()"></sysuser-edit>
			<!--设置用户权限编辑弹窗-->
			<sysuser-auth-config ref="sysuserAuthConfig"  @resolve="$refs.view.update()"></sysuser-auth-config>
			<!--设置用户权限复制弹窗-->
			<sysuser-auth-copy ref="sysuserAuthCopy"></sysuser-auth-copy>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import sysuserEdit from "@/pages/system/sysuser_edit.vue";
	import sysuserAuthConfig from "@/pages/system/sysuser_auth_config.vue";
	import sysuserAuthCopy from "@/pages/system/sysuser_auth_copy.vue";
	export default {
		components: {sysuserEdit, sysuserAuthConfig, sysuserAuthCopy},
		computed: {
			// 获取dictName选项数据
			...mapState(['disableEnableDic', 'saasInfo', 'userTypeDic', 'pricingTypeDic']),
		},

		data() {
			return {
				defaultSearchData: {
					'state': [1]
				}
			}
		},

		methods: {
			/*******搜索角色*****************/
			searchRole(keyword, resolve){
				this.request({
					url:'/system/native/options',
					data: {
						options_code:'ROLE'
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/*******搜索部门*****************/
			searchDepartment(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DEPARTMENT',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/******删除用户***********/
			removeSysuser(data){
				this.$confirm({
					message:'确认删除用户【'+data.user_realname+'】？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******重置密码***********/
			resetPwd(data){
				this.$confirm({
					message:'确定重置用户【'+data.user_realname+'】的登录密码？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/reset_pwd',
							data: {id:data.id},
							loading: true,
							success: result => {
								this.$confirm({
									message: result,
									buttonName: '我知道了',
									cancelButton: false,
									resolve: () => {
									}
								});
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******用户启禁用*********/
			stateHandle(state, next, data) {
				this.request({
					url: '/sys_user/update_state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					success: (data, message) => {
						this.$message({
							message: message,  // 提示内容,
							type: 'success'
						});
						next();
					}
				})
			},
			
			/******账号类型切换*********/
			userTypeHandle(user_type, next, data) {
				this.request({
					url: '/sys_user/update_user_type',
					data: {
						id: data.id,
						user_type: user_type ? 2 : 1
					},
					success: (data, message) => {
						this.$message({
							message: message,  // 提示内容,
							type: 'success'
						});
						next();
					}
				})
			},
			
			/******解锁账户***********/
			riskRemoval(item){
				this.$confirm({
					message:'解锁用户【'+item.user_realname+'】为正常状态？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/riskRemovalByUserId',
							data: {
								user_id: item.id
							},
							loading: true,
							success: (data, message) => {
								this.$message({
									message: message,  // 提示内容,
									type: 'success'
								});
								item.is_lock = 0;
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>